import { bootstrapApplication } from '@angular/platform-browser';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { AppComponent } from './app/app/components/app/app.component';
import { appConfig } from './app/app/app.config';
import { initSentry } from './app/shared/config/sentry.config';
import { captureEntrySource } from './app/shared/utils/entry-source.util';

// Antes de arrancar Angular: el router puede limpiar la URL (redirecciones) y con ella
// los `utm_source` / `fbclid` que dicen de dónde llegó la persona. Se guarda hasta el login.
captureEntrySource();
registerSwiperElements();
initSentry();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
